export { default } from "./table-row";
